export default __webpack_public_path__ + "static/11011-5f659598a9d0bba56ee50b1d0396c423.jpg";